import React, {  } from 'react';
import { ModalWindowCaseSettingsExt } from '../../modal_window';
import { VoteCandidateNew } from './VoteCandidateNew';

export const Vote = (props: ModalWindowCaseSettingsExt) => {

  return <VoteCandidateNew {...props} />;
};
